import { register, find } from '../../../../Javascript/Sysmex/Utils'

const ScrollTop = el => {
  const { duration, animated } = el.dataset

  const trigger = find('.sysmexMoleculeScrollToTop_icon', el)

  trigger.addEventListener('click', e => {
    scroll(duration || 1000, animated)
  })

  document.addEventListener('scroll', e => {
    const topElement = document.scrollingElement || document.documentElement
    if (topElement.scrollTop > window.screen.availHeight * 0.8) {
      el.classList.add('sysmexMoleculeScrollToTop_visible')
    } else {
      el.classList.remove('sysmexMoleculeScrollToTop_visible')
    }
  }, { passive: true })
}

const scroll = (duration = 1000, animated = true) => {
  const topElement = document.scrollingElement || document.documentElement
  const start = topElement.scrollTop
  const change = 0 - start
  let currentTime = 0
  const increment = 20

  const animateScroll = function () {
    currentTime += increment
    const val = Math.easeInOutQuad(currentTime, start, change, duration)
    topElement.scrollTop = val
    if (currentTime < duration) {
      setTimeout(animateScroll, increment)
    }
  }
  animated ? animateScroll() : topElement.scrollTop = 0
}

Math.easeInOutQuad = function (t, b, c, d) {
  t /= d / 2
  if (t < 1) return c / 2 * t * t + b
  t--
  return -c / 2 * (t * (t - 2) - 1) + b
}

register('ScrollTop', ScrollTop)
